// @core/api/endpoints/calendar/export_calendar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExportCalendarResponse,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Export calendar
 * Exports all events from the calendar in iCalendar (.ics) format. Includes recurring event rules and attendee information.
 */
export async function ExportCalendar(
  calendar_id: string,
  options?: RequestOptions
): Promise<ExportCalendarResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendars/:calendar_id/export`;
  requestPath = requestPath.replace(':calendar_id', encodeURIComponent(calendar_id));
  const requestOptions = options;
  return client.get<ExportCalendarResponse>(requestPath, { ...requestOptions });
}
